import React from "react";
import { mapPairingTypeToDataTable as mapData } from "./Helper";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetPairingTypeColumns from "./ColumnDefinition/PairingTypeColumn/GetPairingTypeColumns";

const PairingTypeTable = ({ data, handleOpenPopup, handleDelete, status }) => {
  const columns = GetPairingTypeColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default PairingTypeTable;
